import { Row } from "PFApp/booking/types";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import React, { JSX, useEffect, useState } from "react";

import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "../side_panel_rows.module.scss";
import { PER_PAGE } from "./get_request_data";
import { RowChildrenItem } from "./queries/use_row_children";
import { checkIsLastLevel } from "./side_panel_row.utils";

type RowPaginationProps = {
  row: Row;
  meta: RowChildrenItem["meta"];
  loading: boolean;
  expanded: boolean;
  onPageChange: (page: number) => void;
};

export const RowPagination = ({
  row,
  meta,
  loading,
  expanded,
  onPageChange
}: RowPaginationProps): JSX.Element => {
  const { calendarMode } = useBookingsOverviewContext();

  const [shouldDisplayPagination, setShouldDisplayPagination] = useState(false);
  const { page, total, totalPages } = meta;
  const rangeText = `(${(page - 1) * PER_PAGE + 1} - ${Math.min(page * PER_PAGE, total)})`;
  const isLastLevel = checkIsLastLevel(calendarMode, row);

  useEffect(() => {
    if (loading) {
      return;
    }
    setShouldDisplayPagination(!isLastLevel && !!total && total > PER_PAGE && expanded && totalPages > 1);
  }, [isLastLevel, total, expanded, loading, totalPages]);

  return (
    <>
      {shouldDisplayPagination && (
        <div className={css.pagination}>
          <span className={css.rangeText}>{rangeText}</span>
          <SimplePagination
            className={css.paginationButtons}
            currentPage={page}
            handleClick={onPageChange}
            totalPages={totalPages}
            scrollOnClick={false}
            customSpan={totalPages > 3 ? 1 : 2}
          />
        </div>
      )}
    </>
  );
};
